// Hooks
import { useAlbumContext } from '@/utils/hooks/context/useAlbumContext';

import PropTypes from 'prop-types';

// Lib
import { ALBUM_MANUAL_STEP } from '@/lib/albums/albumFunnel/steps';

// Components
import Modal from '@/components/base/Modal';
import { ModalSteps } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps';

const FunnelModalContent = ({ isOpen, toggle, callbackUpdateAlbum }) => {
    const { albumInfo } = useAlbumContext();
    const modalSize = albumInfo?.currentStep === ALBUM_MANUAL_STEP ? '6xl' : '5xl';

    return (
        <Modal open={isOpen} onDismiss={toggle} wrapperWidthFull={false} size={modalSize}>
            <ModalSteps dismiss={toggle} callbackUpdateAlbum={callbackUpdateAlbum} />
        </Modal>
    );
};

FunnelModalContent.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    callbackUpdateAlbum: PropTypes.func
};

export default FunnelModalContent;
